import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import React from "react";
import { Button, Field } from "@qgiv/core-donor";

const EmailSharingModalContent = ({
    emailLabel,
    messageLabel,
    subjectLabel,
    heading,
    additionalText = "",
    linkFinePrint,
    submitButtonLabel,
    cancelButtonLabel,
    setAppEmailModalOpen,
}) => {
    const dispatch = useDispatch();
    const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
        useFormikContext();
    const handleCancel = () => {
        dispatch(setAppEmailModalOpen(false));
    };

    const fieldNames = ["Email_Address", "Email_Subject", "Email_Message"];
    const fieldLabels = {
        Email_Address: emailLabel,
        Email_Message: messageLabel,
        Email_Subject: subjectLabel,
    };
    return (
        <div className="email-modal-content">
            {/* eslint-disable-next-line tailwindcss/classnames-order */}
            <div className="grid grid--justify-content-center -padding-bottom--50">
                <div className="col col--8">
                    <div className="grid">
                        <div className="col col--12 -text--center">
                            <h1>{heading}</h1>
                            {additionalText && <p>{additionalText}</p>}
                        </div>

                        {fieldNames.map((fieldName) => (
                            <div className="col col--12" key={fieldName}>
                                <Field
                                    id={fieldName}
                                    name={fieldName}
                                    label={fieldLabels[fieldName]}
                                    value={values[fieldName]}
                                    type="text"
                                    multiline={fieldName === "Email_Message"}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    error={
                                        touched[fieldName] &&
                                        errors[fieldName] &&
                                        errors[fieldName].length > 0
                                    }
                                    errorText={errors[fieldName]}
                                />
                            </div>
                        ))}

                        <div className="col col--12 -text--center -margin-top--20 -margin-bottom--20">
                            <small>{linkFinePrint}</small>
                        </div>

                        {/* Buttons */}
                        <div className="col col--12">
                            <Button onClick={handleSubmit}>
                                {submitButtonLabel}
                            </Button>
                        </div>
                        <div className="col col--12">
                            <Button
                                classes="button button--secondary"
                                onClick={handleCancel}
                            >
                                {cancelButtonLabel}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

EmailSharingModalContent.propTypes = {
    emailLabel: PropTypes.string.isRequired,
    messageLabel: PropTypes.string.isRequired,
    subjectLabel: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    linkFinePrint: PropTypes.string.isRequired,
    submitButtonLabel: PropTypes.string.isRequired,
    cancelButtonLabel: PropTypes.string.isRequired,
    setAppEmailModalOpen: PropTypes.func.isRequired,
};

export default EmailSharingModalContent;
